import { atomWithStorage } from 'jotai/utils';
import { SyncStorage } from 'jotai/vanilla/utils/atomWithStorage';
import { makeJotaiSessionStorage } from './createSessionStorage';

const initialCompanyInfoAtom: CompanyInfor = {
  companyidx: 0,
  companyname: '',
  category: '',
  categoryidx: 0,
  centeridx: 0,
  salestypeidx: 1
};

const localStorageKey = 'companyInformation';
const companyInforAtom = atomWithStorage(
  localStorageKey,
  initialCompanyInfoAtom,
  makeJotaiSessionStorage() as SyncStorage<CompanyInfor>
);

export default companyInforAtom;
